import React from "react";
import * as S from "./KycStatus.styled";
import { greenMark } from "../../assets";
import { useAppSelector } from "../../redux/hooks";

export const KycStatus = () => {
  const kyc = useAppSelector((state) => state.user.userData.kyc);

  const getKycStatus = () => kyc?.status ?? "not verified";
  return (
    <S.StatusParagraph status={getKycStatus()}>
      {getKycStatus() === "approved" && (
        <img src={greenMark} alt="green mark icon" />
      )}
      {getKycStatus()}
    </S.StatusParagraph>
  );
};
